import * as S from './layout';

const CatalogContentSkeleton = () => {
  return (
    <S.SkeletonGridContent role="progressbar">
      <S.SkeletonBreadCrumbs />
      <S.SkeletonImage />
      <S.SkeletonProductDescription>
        <S.TextLineBig />
        <S.TextLineMedium />
        <S.TextLineSmall />
        <S.SkeletonAddToCart />
      </S.SkeletonProductDescription>
      <S.SkeletonProductInfos>
        <S.TextLineBig />
        <S.TextLineMedium />
        <S.TextLineSmall />
        <S.TextLineSmall />
      </S.SkeletonProductInfos>
    </S.SkeletonGridContent>
  );
};

export default CatalogContentSkeleton;
